import BasicResource from '@/api/resource';
import apiClient from '@/api/client';

class BannersResource extends BasicResource {

    constructor () {
        super('banners');
    }

    groupedList (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/banners/grouped',
            params,
        });
    }

    upload (file) {
        let xhr = new XMLHttpRequest();

        xhr.open('PUT', `/api/upyield/v1/banners/${file.data.banner_id}/upload`);
        xhr.setRequestHeader('Authorization', apiClient.getAuthHeaders().Authorization);

        return this.uploadXhr(xhr, file, file.file);
    }
}

export default new BannersResource;
